import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import PartnerPageTemplate from "@/components/partners/PartnerPageTemplate";
import { urbanLeague } from "@/data/partners";

export const Route = createFileRoute("/partners/urban-league")({
  head: () => seoHead("/partners/urban-league"),
  component: () => <PartnerPageTemplate partner={urbanLeague} />,
});
